/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CustomErrorCode {
  EMPLOYEE_ASSIGNMENT_EXCEPTION = 'employee_assignment_exception',
  RESOURCE_ASSIGNMENT_EXCEPTION = 'resource_assignment_exception',
  PENDING_ORDER_BLOCKING_EXCEPTION = 'pending_order_blocking_exception',
}
